import React, { useState } from "react";
import { Box, Grid, Typography, Button, MenuItem } from "@mui/material";
import { AiOutlineMinus } from "react-icons/ai";
import AddIcon from "@mui/icons-material/Add";
import styles from "./HomeNew.module.css";
import home_images from "../../assets/images/AI Home.jpg";
import { customTextColor } from "../../utils/const";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/Latest Logo.png";
import Footer from "./HomeFooter";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { GoLightBulb } from "react-icons/go";
import { RxHamburgerMenu } from "react-icons/rx";
import Fade from "react-reveal/Fade";


const Privacy = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  return (
    <Box>
      <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>
        <span className={styles.nav_links}>
          <a onClick={() => navigate("/")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Home
            </b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "5px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Our Platform
            </b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              About us
            </b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Contact us
            </b>
          </a>
          <Box className={styles.login_btn}>
            <a onClick={() => navigate("/login")}>
              <b>Login</b>
            </a>
          </Box>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("/")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Home
              </Typography>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "20px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </Typography>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                About us
              </Typography>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Contact us
              </Typography>
            </a>
            <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                <b>Login</b>
              </a>
            </Box>
          </Box>
        )}
      </Box>
      <Box sx={{ padding: "35px" }} id="home" />
      <Box className={styles.home_structure}>
        <Fade bottom delay={200}>
          <Box className={styles.configuration_structure}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={4}
                md={3}
                sx={{ backgroundColor: "#fff", border: "2px solid #f2f2f2" }}
              >
                <Box className={styles.security_body}>
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      color: customTextColor,
                      fontSize: "17px !important",
                      margin: "4px 0",
                    }}
                    onClick={() => navigate("/privacy-policy")}
                  >
                     <b style={{ borderBottom: "2px solid #1991e0" }}>Privacy Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/refund-policy")}
                >
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Refund Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/term-of-use")}
                >
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Website Terms of Use</b>
                  </Box>
                </Box>

                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/data-backup-policy")}
                >
                  <Box
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Data Backup Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/safe-job-search")}
                >
                  <Box
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Safe Job Search & Applies Security </b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  onClick={() => navigate("/reporting-fraud")}
                  style={{ margin: "14px 0" }}
                >
                  <Box
                    aria-controls="panel3-content"
                    id="panel3-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Reporting fraud</b>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
                md={9}
                style={{
                  paddingLeft: window.innerWidth < 600 ? "15px" : "0",
                }}
              >
                <Box className={styles.employer_details}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      padding: "10px 30px 55px 20px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{ fontSize: "20px !important", userSelect: "none" }}
                      >
                        <b>Privacy Policy</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Effective date: April, 10, 2024
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        At Povital.com. (“Povital”) we take your privacy
                        seriously. Please read this Privacy Policy to learn how
                        we treat your personal information. By using or
                        accessing our website in any manner, you acknowledge
                        that you accept the practices and policies outlined
                        below, and you hereby consent that we will collect, use
                        and share your information as described in this Privacy
                        Policy.
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Remember that your use of Povital’s site is at all times
                        subject to our Terms of Use, which incorporates this
                        Privacy Policy. Any terms we use in this Policy without
                        defining them have the definitions given to them in the
                        Terms of Use. Please note that this privacy policy
                        applies only to the information collected through our
                        website and not information collected offline.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <Typography>
                          1){" "}
                          <span style={{ textDecoration: "underline" }}>
                            What this Privacy Policy Covers
                          </span>
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "16px !important",
                            marginTop: "15px",
                            userSelect: "none",
                          }}
                        >
                          This Privacy Policy covers how we treat Personal Data
                          that we gather when you access or use our Site.
                          “Personal Data” means any information that identifies
                          or relates to a particular individual and also
                          includes information referred to as “personally
                          identifiable information” or “personal information”
                          under applicable data privacy laws, rules or
                          regulations. This Privacy Policy does not cover the
                          practices of companies we don’t own or control or
                          people we don’t manage.
                        </Typography>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        2){" "}
                        <span style={{ textDecoration: "underline" }}>
                          What Information Does Povital Collect?
                        </span>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          fontWeight: "600",
                          userSelect: "none",
                        }}
                      >
                        A. Personal Data Collected for Povital‘s Customers Via
                        Our ATS or Work Force Platforms (the “Povital Services”)
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        When Povital collects and uses Personal Data in the
                        performance of the Povital Services for our business
                        customers the following provisions will apply:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        The Personal Data Collected for Povital‘s Customers
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Povital may collect, receive, process, and store
                        Personal Data under the direction of its customers in
                        the course of providing those customers with the Povital
                        Services. This Personal Data may include, but is not
                        limited to, Personal Data as your name, phone number,
                        job title, employer name, mailing address, email
                        addresses, and other information identifiable to you
                        such as information one would ordinarily expect to find
                        on a resume. In addition, we collect Personal Data from
                        our customers’ authorized users and account
                        administrators (typically, their employees or agents) in
                        order to provide them with accounts to access the
                        Povital Services. This information may include, but is
                        not limited to, credential and profile data (such as
                        name, contact information, employer, job title, and
                        other relevant information).
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Povital has no direct relationship with the consumers
                        whose Personal Data Povital collects in the course of
                        providing the Povital Services. All such information is
                        owned and controlled by our customers, who are the data
                        controllers for such information with respect to data
                        protection laws.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        How We Use the Personal Data Collected by Povital‘s
                        Customers
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Povital may use this information for various purposes
                        for the benefit of its customers, including, but not
                        limited to, providing them with contracted Povital
                        Services.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Access to Personal Data Controlled by Povital’s
                        Customers
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Povital has no direct relationship with the consumers
                        whose Personal Data Povital receives in the course of
                        providing the Povital Services to its customers. An
                        individual consumer who seeks access, or who seeks to
                        correct, amend, or delete inaccurate Personal Data
                        should direct his query to Povital’s customer. If the
                        customer then requests Povital to correct, amend, or
                        delete the data in Povital’s possession or control, we
                        will respond to their request promptly.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Retention of Personal Data
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Povital will retain Personal Data we receive in the
                        course of providing the Povital Services to our
                        customers for as long as (i) directed by the customers
                        or otherwise agreed to with them, (ii) otherwise needed
                        to provide the Povital Services to the customers and
                        (iii) as necessary to comply with our legal obligations,
                        resolve disputes, and enforce our agreements.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          fontWeight: "600",
                          userSelect: "none",
                        }}
                      >
                        B. Personal Data Collected from Visitors to Our Websites
                        and through Povital Sales, Marketing, and Support
                        Activities
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We gather various types of Personal Data such as name,
                        email address, company name, phone number, and device
                        type from our users, as explained more fully below. We
                        may use this Personal Data to personalize and improve
                        our Site, to contact users, to fulfill your requests for
                        certain products and services, to analyze how users
                        utilize the Site, and as otherwise set forth in this
                        Privacy Policy. We may share certain types of Personal
                        Data with third parties (described in this Section and
                        in Section 5 below).
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        The following chart details the categories of Personal
                        Data that we collect and have collected over the past 12
                        months from visitors to our websites and through Povital
                        sales, marketing and customer support activities. For
                        each category of Personal Data, these subsections also
                        set out our commercial and business purpose for
                        collecting that Personal Data and the categories of
                        third parties with whom we share that Personal Data.
                        More information regarding those sources and categories
                        is set forth in the charts below. The chart in this
                        section details the categories of Personal Data that we
                        collect and have collected over the past 12 months:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        3){" "}
                        <span style={{ textDecoration: "underline" }}>
                          Categories of Sources of Personal Data
                        </span>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          textDecoration: "underline",
                          userSelect: "none",
                        }}
                      >
                        Sources of Personal Data
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We collect Personal Data about you from the following
                        categories of sources:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>“You”</li>
                          <ul>
                            <li style={{ listStyle: "circle" }}>
                              When you provide such information directly to us.
                            </li>
                            <li style={{ listStyle: "circle" }}>
                              When Personal Data about you is automatically
                              collected in connection with your use of our Site
                              (see the subsection titled “Information Collected
                              Automatically” below).
                            </li>
                          </ul>
                        </ul>
                        <ul>
                          <li>“Third Parties”</li>
                          <ul>
                            <li style={{ listStyle: "circle" }}>
                              Third parties that provide us with Personal Data
                              about you. Third Parties that share your Personal
                              Data with us include:
                            </li>
                          </ul>
                          <ul>
                            <ul>
                              <li style={{ listStyle: "square" }}>
                                Service providers. For example, we may use
                                analytics service providers to analyze how you
                                interact and engage with the Site, or third
                                parties may help us provide you with customer
                                support.
                              </li>
                              <li style={{ listStyle: "square" }}>
                                Our business customers. If you share Personal
                                Data with our business customers, they may share
                                that information with us in order to chat or
                                email with you through the Site and to store
                                your information on the Site.
                              </li>
                              <li style={{ listStyle: "square" }}>
                                Advertising partners. We receive information
                                about you from some of our service providers who
                                assist us with marketing or promotional services
                                related to how you interact with our websites,
                                applications, products, services, advertisements
                                or communications.
                              </li>
                            </ul>
                          </ul>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        4){" "}
                        <span style={{ textDecoration: "underline" }}>
                          How we use the Personal Data we Collect
                        </span>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We process Personal Data to operate, improve, understand
                        and personalize our Site. We may use Personal Data for
                        the following purposes:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            To meet or fulfill the reason you provided the
                            information to us.
                          </li>
                          <li>
                            To communicate with you about the Site, including
                            Service announcements, updates or offers.
                          </li>
                          <li>
                            To provide support and assistance for the Site.
                          </li>
                          <li>
                            To respond to user inquiries and fulfill user
                            requests.
                          </li>
                          <li>
                            To improve and develop the Site, including testing,
                            research, analysis and product development.
                          </li>
                          <li>
                            To protect against or deter fraudulent, illegal or
                            harmful actions and maintain the safety, security
                            and integrity of our Site.
                          </li>
                          <li>
                            To comply with our legal or contractual obligations,
                            resolve disputes, and enforce our Terms of Use.
                          </li>
                          <li>
                            To respond to law enforcement requests and as
                            required by applicable law, court order, or
                            governmental regulations.
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We will not collect additional categories of Personal
                        Data or use the Personal Data we collected for
                        materially different, unrelated, or incompatible
                        purposes without providing you notice.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        As noted in the list above, we may communicate with you
                        if you’ve provided us the means to do so. For example,
                        if you’ve given us your email address, we may send you
                        promotional email offers or email you about your use of
                        the Site. Also, we may receive a confirmation when you
                        open an email from us, which helps us improve our Site.
                        If you do not want to receive communications from us,
                        please indicate your preference by emailing us at
                        compliance@Povital.com.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        5){" "}
                        <span style={{ textDecoration: "underline" }}>
                          With Whom Do We Share Your Personal Data for Business
                          Purposes
                        </span>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We disclose your Personal Data as indicated in the chart
                        above to the following categories of service providers
                        and other parties:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li> “Service Providers”</li>
                          <ul>
                            <li style={{ listStyle: "circle" }}>
                              These are third parties that help us provide our
                              services through the Site, including, ad networks,
                              security and fraud prevention providers, hosting
                              and other technology and communications providers,
                              analytics providers, and staff augmentation and
                              contract personnel.
                            </li>
                          </ul>
                        </ul>
                        <ul>
                          <li>“Acquirors”</li>
                          <ul>
                            <li style={{ listStyle: "circle" }}>
                              These are parties who acquire your Personal Data
                              through an acquisition or other change of control.
                              Personal Data may be transferred to a third party
                              if we undergo a merger, acquisition, bankruptcy or
                              other transaction in which that third party
                              assumes control of our business (in whole or in
                              part).
                            </li>
                          </ul>
                        </ul>
                        <ul>
                          <li>“Selected Recipients”</li>
                          <ul>
                            <li style={{ listStyle: "circle" }}>
                              These are third parties that we share your
                              Personal Data with at your direction, including:
                            </li>
                          </ul>
                          <ul>
                            <ul>
                              <li style={{ listStyle: "square" }}>
                                Third-party business partners who you access
                                through the Site.
                              </li>
                              <li style={{ listStyle: "square" }}>
                                Other parties authorized by you
                              </li>
                            </ul>
                          </ul>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We may share your Personal Data to service providers and
                        other parties for the following business purposes:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            {" "}
                            Detecting security incidents, protecting against
                            malicious, deceptive, fraudulent or illegal
                            activity, and prosecuting those responsible for that
                            activity.
                          </li>
                          <li>
                            {" "}
                            Debugging to identify and repair errors that impair
                            existing intended functionality.
                          </li>
                          <li>
                            {" "}
                            Short-term, transient use of Personal Data that is
                            not used by another party to build a consumer
                            profile or otherwise alter your consumer experience
                            outside the current interaction.
                          </li>
                          <li>
                            {" "}
                            Performing services on our behalf, including
                            maintaining or servicing accounts, providing
                            customer service, processing or fulfilling orders
                            and transactions, verifying customer information,
                            processing payments, or providing similar services
                            on behalf of the business or service provider.
                          </li>
                          <li>
                            {" "}
                            Undertaking internal research for technological
                            development and demonstration.
                          </li>
                          <li>
                            {" "}
                            Undertaking activities to verify or maintain the
                            quality or safety of a service or device that we
                            own, manufacture (or that was manufactured for us)
                            or control.
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        6){" "}
                        <span style={{ textDecoration: "underline" }}>
                          Data Security and Retention
                        </span>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We seek to protect your Personal Data from unauthorized
                        access, use and disclosure using appropriate physical,
                        technical, organizational and administrative security
                        measures based on the type of Personal Data and how we
                        are processing that data. We implement a variety of
                        security measures to maintain the safety of your
                        personal information when you submit a request, place an
                        order or enter, submit, or access your personal
                        information. These security measures include: password
                        protected directories and databases to safeguard your
                        information, SSL (Secure Sockets Layered) technology to
                        ensure that your information is fully encrypted and sent
                        across the Internet securely, and PCI Scanning to
                        actively protect our servers from hackers and other
                        vulnerabilities.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        The Website may contain links to other sites. We are not
                        responsible for the privacy policies and/or practices on
                        other sites. When following a link to another site you
                        should read that site’s privacy policy.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We retain Personal Data about you for as long as you
                        have an open account with us or as otherwise necessary
                        to provide you with our Site. In some cases, we retain
                        Personal Data for longer, if doing so is necessary to
                        comply with our legal obligations, resolve disputes or
                        collect fees owed, or is otherwise permitted or required
                        by applicable law, rule or regulation. We may further
                        retain information in an anonymous or aggregated form
                        where that information would not identify you
                        personally.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        7){" "}
                        <span style={{ textDecoration: "underline" }}>
                          Personal Data of Children
                        </span>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        As noted in the Terms of Use, we do not knowingly
                        collect or solicit Personal Data about children under 16
                        years of age; if you are a child under the age of 16,
                        please do not attempt to register for or otherwise use
                        the site or send us any Personal Data. If we learn we
                        have collected Personal Data from a child under 16 years
                        of age, we will delete that information as quickly as
                        possible. If you believe that a child under 16 years of
                        age may have provided Personal Data to us, please
                        contact us at compliance@Povital.com.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        8){" "}
                        <span style={{ textDecoration: "underline" }}>
                          What Choices Do I Have?
                        </span>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        You can always opt not to disclose information to use,
                        but keep in mind some information may be needed to
                        register with us or to take advantage of some of our
                        special features.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        You may be able to add, update, or delete information by
                        emailing us at to compliance@povital.com. When you
                        update information, however, we may maintain a copy of
                        the unrevised information in our records. You may
                        request deletion of your account via email to
                        compliance@povital.com. Please note that some
                        information may remain in our private records after your
                        deletion of such information from your account if doing
                        so is necessary to comply with our legal obligations,
                        resolve disputes or collect fees owed, or is otherwise
                        permitted or required by applicable law, rule or
                        regulation. We may use any aggregated data derived from
                        or incorporating your Personal Data after you update or
                        delete it, but not in a manner that would identify you
                        personally.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We collect information for our customers, if you have
                        been contacted by one of our customers and would no
                        longer like to be contacted by one of our customers
                        through use of our service, please contact the customer
                        that you interact with directly. Povital will retain
                        personal data we process on behalf of our customers for
                        as long as needed to provide services to our customer.
                        Povital will retain and use this Personal Data as
                        necessary to comply with our legal obligations, resolve
                        disputes, and enforce our agreements.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        If you do not wish to receive email or other mail from
                        us, please contact us via email at
                        compliance@povital.com or follow the unsubscribe
                        instructions in each promotional email. Please note that
                        if you do not want to receive legal notices from us,
                        such as this Privacy Policy, those legal notices will
                        still govern your use of the Website, and you are
                        responsible for reviewing such legal notices for
                        changes.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        If you are a resident of United States of America or the
                        European Union, you may have additional rights. Please
                        see the United States of America Rights and sections
                        below for more information.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        9){" "}
                        <span style={{ textDecoration: "underline" }}>
                          Changes to this Privacy Policy
                        </span>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We may amend this Privacy Policy from time to time. Use
                        of information we collect now is subject to the Privacy
                        Policy in effect at the time such information is used.
                        If we make any material changes, we will notify you by
                        email (sent to the e-mail address specified in your
                        account) or by means of a notice on this Site prior to
                        the change becoming effective. We encourage you to
                        periodically review this page for the latest information
                        on our privacy practices.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        10){" "}
                        <span style={{ textDecoration: "underline" }}>
                          United States of America Resident Rights
                        </span>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        If you are a United States of America resident, you have
                        the rights set forth in this section. Please see the
                        “Exercising Your Rights” section below for instructions
                        regarding how to exercise these rights. Please note that
                        we may process Personal Data of our customers’ end users
                        or employees in connection with our provision of certain
                        services to our customers. If we are processing your
                        Personal Data as a service provider, you should contact
                        the entity that collected your Personal Data in the
                        first instance to address your rights with respect to
                        such data.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        If there are any conflicts between this section and any
                        other provision of this Privacy Policy and you are a
                        United States of America resident, the portion that is
                        more protective of Personal Data shall control to the
                        extent of such conflict. If you have any questions about
                        this section or whether any of the following rights
                        apply to you, please contact us at
                        compliance@povital.com.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          textDecoration: "underline",
                          userSelect: "none",
                        }}
                      >
                        Access
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        You have the right to request certain information about
                        our collection and use of your Personal Data over the
                        past 12 months. In response, we will provide you with
                        the following information:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            The categories of Personal Data that we have
                            collected about you.
                          </li>
                          <li>
                            The categories of sources from which that Personal
                            Data was collected.
                          </li>
                          <li>
                            The business or commercial purpose for collecting or
                            selling your Personal Data.
                          </li>
                          <li>
                            The categories of third parties with whom we have
                            shared your Personal Data
                          </li>
                          <li>
                            The specific pieces of Personal Data that we have
                            collected about you.
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        If we have disclosed your Personal Data to any third
                        parties for a business purpose over the past 12 months,
                        we will identify the categories of Personal Data shared
                        with each category of third-party recipient. If we have
                        sold your Personal Data over the past 12 months, we will
                        identify the categories of Personal Data sold to each
                        category of third-party recipient.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          textDecoration: "underline",
                          userSelect: "none",
                        }}
                      >
                        Deletion
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        You have the right to request that we delete the
                        Personal Data that we have collected about you. Under
                        the CCPA, this right is subject to certain exceptions:
                        for example, we may need to retain your Personal Data to
                        provide you with the Site or complete a transaction or
                        other action you have requested. If your deletion
                        request is subject to one of these exceptions, we may
                        deny your deletion request.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          textDecoration: "underline",
                          userSelect: "none",
                        }}
                      >
                        Exercising Your Rights
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        To exercise the rights described above, you must send us
                        a request that (1) provides sufficient information to
                        allow us to verify that you are the person about whom we
                        have collected Personal Data, and (2) describes your
                        request in sufficient detail to allow us to understand,
                        evaluate and respond to it. Each request that meets both
                        of these criteria will be considered a “Valid Request.”
                        We may not respond to requests that do not meet these
                        criteria. We will only use Personal Data provided in a
                        Valid Request to verify your identity and complete your
                        request. You do not need an account to submit a Valid
                        Request.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We will work to respond to your Valid Request within 45
                        days of receipt. We will not charge you a fee for making
                        a Valid Request unless your Valid Request(s) is
                        excessive, repetitive or manifestly unfounded. If we
                        determine that your Valid Request warrants a fee, we
                        will notify you of the fee and explain that decision
                        before completing your request.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        You may submit a Valid Request using the following
                        methods:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>Call us at: +1-585-296-4563</li>
                          <li>Email us at: compliance@povital.com</li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        You may also authorize an agent (an “Authorized Agent”)
                        to exercise your rights on your behalf. To do this, you
                        must provide your Authorized Agent with written
                        permission to exercise your rights on your behalf, and
                        we may request a copy of this written permission from
                        your Authorized Agent when they make a request on your
                        behalf.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          textDecoration: "underline",
                          userSelect: "none",
                        }}
                      >
                        We Will Not Discriminate Against You for Exercising Your
                        Rights Under the CCPA
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We will not discriminate against you for exercising your
                        rights under the CCPA. We will not deny you our goods or
                        services, charge you different prices or rates, or
                        provide you a lower quality of goods and services if you
                        exercise your rights under the CCPA. However, we may
                        offer different tiers of our Site as allowed by
                        applicable data privacy laws (including the CCPA) with
                        varying prices, rates or levels of quality of the goods
                        or services you receive related to the value of Personal
                        Data that we receive from you.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          textDecoration: "underline",
                          userSelect: "none",
                        }}
                      >
                        Other United States of America Resident Rights
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Under United States of America Civil Code Sections
                        1798.83-1798.84, United States of America residents are
                        entitled to contact us to prevent disclosure of Personal
                        Data to third parties for such third parties’ direct
                        marketing purposes; in order to submit such a request,
                        please contact us at compliance@povital.com.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        What Personal Data Do We Collect from You and How Do We
                        Use It?
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Please refer to{" "}
                        <b style={{ color: "#33629c" }}>
                          Section 3 – What Information Does Povital Collect?
                        </b>{" "}
                        and{" "}
                        <b style={{ color: "#33629c" }}>
                          Section 4 – How We Use the Personal Data We Collect
                        </b>{" "}
                        above for information about the Personal Data we collect
                        about you and how we use it.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        On What Basis Do We Justify Processing Your Personal
                        Data
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We will only process your Personal Data if we have a
                        lawful basis for doing so. Lawful bases for processing
                        include consent, contractual necessity and our
                        “legitimate interests” or the legitimate interest of
                        others, as further described below, and depending on the
                        Personal Data involved and the specific context in which
                        we collect it. Povital’s processing of your Personal
                        Data is justified on one or more of the following legal
                        bases:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Performance of Contract: The processing is necessary to
                        perform a contract with you or take steps to enter into
                        a contract at your request. When we process data due to
                        contractual necessity, failure to provide such Personal
                        Data will result in your inability to use some or all
                        portions of the Site that require such data. Examples
                        include: name, email address, address and phone number.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Our Legitimate Interests: The processing is in our
                        legitimate interests, subject to your interests and
                        fundamental rights, and notably our legitimate interest
                        in using applicable data to conduct and develop our
                        business activities, such as developing and maintaining
                        relationships with our customers, our operation and
                        improvement of our business, products and services,
                        marketing of our products and services, provision of
                        customer support, protection from fraud or security
                        threats, compliance with legal obligations, and
                        completion of corporate transactions. Examples include:
                        name, email address, address, phone number, Content, and
                        information about you that is automatically collected
                        when you use the Site as detailed above.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Compliance with Law: The processing is necessary for us
                        to comply with a relevant legal obligation;
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        With Your Consent: You have consented to the processing
                        (for example, where we are required by local law to rely
                        upon your prior consent for the purposes of direct
                        marketing); or
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Defend Our Rights; Protect Vital Interests: The
                        processing is necessary to the establishment, exercise,
                        or defense of legal claims or rights or to protect your
                        vital interests or those of another person.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        How and with Whom Do We Share Your Data?
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Please refer to{" "}
                        <b style={{ color: "#33629c" }}>
                          Section 5 – With Whom Do We Share Your Personal Data
                          for Business Purposes?
                        </b>{" "}
                        above for information about how and with whom we share
                        your Personal Data.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        What Rights Do You Have Regarding Your Personal Data?
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        You have certain rights with respect to your Personal
                        Data, including those set forth below. For more
                        information about these rights, or to submit a request,
                        please email compliance@povital.com. Please note that in
                        some circumstances, we may not be able to fully comply
                        with your request, such as if it is frivolous or
                        extremely impractical, if it jeopardizes the rights of
                        others, or if it is not required by law, but in those
                        circumstances, we will still respond to notify you of
                        such a decision. In some cases, we may also need to you
                        to provide us with additional information, which may
                        include Personal Data, if necessary to verify your
                        identity and the nature of your request.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Special Note Regarding Personal Data Processed by
                        Povital through the Povital Services: If Povital has
                        collected or is otherwise processing your Personal Data
                        through a Povital‘s customer’s use of the Povital
                        Services you should contact that customer in the first
                        instance to address your rights with respect to the
                        Personal Data.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Access: You can request more information about the
                        Personal Data we hold about you and request a copy of
                        such Personal Data.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Rectification: If you believe that any Personal Data we
                        are holding about you is incorrect or incomplete, you
                        can request that we correct or supplement such data.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Erasure: You can request that we erase some or all of
                        your Personal Data from our systems.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Withdrawal of Consent: If we are processing your
                        Personal Data based on your consent (as indi cated at
                        the time of collection of such data), you have the right
                        to withdraw your consent at any time. Please note,
                        however, that if you exercise this right, you may have
                        to then provide express consent on a case - by-case
                        basis for the use or disclosure of certain of your
                        Personal Data, if such use or disclosure is necessary to
                        enable you to utilize some or all of our Site.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Portability: You can ask for a copy of your Personal
                        Data in a machine-readable format. You can also request
                        that we transmit the data to another controller where
                        technically feasible.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Objection: You can contact us to let us know that you
                        object to the further use or disclosure of your Personal
                        Data for certain purposes, such as for direct marketing
                        purposes.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Restriction of Processing: You can ask us to restrict
                        further processing of your Personal Data
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Right to File Complaint: You have the right to lodge a
                        complaint about Povital’s practices with respect to your
                        Personal Data with the supervisory authority of your
                        country or EU Member State.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Transfers of Personal Data
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        The Site is hosted and operated in the United States
                        (“U.S.”) through Povital and its service providers, and
                        if you do not reside in the U.S., laws in the U.S. may
                        differ from the laws where you reside. By using the
                        Site, you acknowledge that any Personal Data about you,
                        regardless of whether provided by you or obtained from a
                        third party, is being provided to Povital in the U.S.
                        and will be hosted on U.S. servers, and you authorize
                        Povital to transfer, store and process your information
                        to and in the U.S., and possibly other countries. You
                        hereby consent to the transfer of your data to the U.S.
                        pursuant to another safeguard(s) for cross-border
                        transfer: (i) a data processing agreement incorporating
                        standard data protection clauses promulgated by the EC,
                        a copy of which can be obtained at, (ii) binding
                        corporate rules for data protection that align with the
                        GDPR’s requirements, or (iii) adherence to an industry-
                        or technology-specific approved code of conduct blessed
                        by the EC.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        13){" "}
                        <span style={{ textDecoration: "underline" }}>
                          Questions or Concerns
                        </span>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        If you have any questions or concerns regarding our
                        privacy policies, please send us a detailed message to
                        compliance@povital.com or Povital, Attn. Privacy Policy
                        687 Lee Road, Suite 208A, Rochester, NY 14606. We will
                        make every effort to resolve your concerns.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Website design and coding provided and warranted by
                        Mythee Software Development Pvt Ltd.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Gmail Add-On
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        It’s important to Povital to help our customers retain
                        their privacy because we believe your business is no one
                        else’s. To protect your privacy, Povital follows
                        different principles in accordance with worldwide
                        practices for customer privacy and data protection.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b> What information do you collect?</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We collect information from you when you register on our
                        site, place an order, subscribe to our newsletter,
                        respond to a survey, or fill out a form. Any data we
                        request that is not required will be specified as
                        voluntary or optional.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        When ordering or registering on our site, you may be
                        asked to enter your name, e- mail address, mailing
                        address, phone number, and any other relevant
                        information required for us to share and present our
                        information to our customers. You may, however, visit
                        our site anonymously.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b> What do you use the information for?</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Any of the information we collect from you may be used
                        in one of the following ways:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li> To personalize your experience</li>
                          <li>To improve our website</li>
                          <li> To improve customer service</li>
                          <li>To process transactions</li>
                          <li>To send periodic emails</li>
                          <li>
                            To administer a contest, promotion, survey, or other
                            site feature
                          </li>
                          <li>
                            To alert you to product upgrades, special offers,
                            updated information, & other new services
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b> How do you protect information?</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We implement a variety of security measures to maintain
                        the safety of your personal information when you submit
                        a request, place an order or enter, submit, or access
                        your personal information.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        These security measures include: password protected
                        directories and databases to safeguard your information,
                        SSL (Secure Sockets Layered) technology to ensure that
                        your information is fully encrypted and sent across the
                        Internet securely, and PCI Scanning to actively protect
                        our servers from hackers and other vulnerabilities.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We use a secure server, so all supplied sensitive/credit
                        information is transmitted via Secure Socket Layer (SSL)
                        technology and then encrypted into our Payment gateway
                        providers database only to be accessible by those
                        authorized with special access rights to such systems.
                        After a transaction, your private information (credit
                        cards, social security numbers, financials, etc.) will
                        not be stored on our servers.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b> Do you use Cookies?</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Yes. Cookies are small files that a site or its service
                        provider transfers to your computer’s hard drive through
                        your Web browser that enables the sites’ or service
                        providers’ systems to recognize your browser and capture
                        and remember certain information. This helps the site
                        remember user preferences and create a more personalized
                        experience.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>
                          {" "}
                          Do you disclose any information to outside parties?
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We do not sell, trade, or otherwise transfer your
                        personally identifiable information to parties not
                        relevant to our business or the purpose of data
                        collected to for your service. This does not include
                        trusted third parties who assist us in operating our
                        website, conducting our business, or servicing you.
                        However, non-personally identifiable visitor information
                        may be provided to other parties for marketing,
                        advertising, or other uses.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We may disclose your personal information, without
                        notice, if required to do so by law or in the belief
                        that such action is necessary to:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            {" "}
                            Conform to the edicts of the law or comply with
                            legal process served on the site
                          </li>
                          <li>
                            {" "}
                            Protect and defend the rights or property of Povital
                            and its family of websites
                          </li>

                          <li>
                            {" "}
                            Act in urgent circumstances to protect the personal
                            safety of users of v, its websites, or the public
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b> Consent</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        If you choose not to register or provide personal
                        information, you can still use most of website. However,
                        you will not be able to access areas that require
                        registration.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        If you decide to register, you will be able to select
                        the kinds of information you want to receive from us by
                        subscribing to various services, like our electronic
                        newsletters, product brochures, and trail subscriptions
                        to platform portals. If you do not want us to
                        communicate with you about other offers regarding
                        products, programs, events, or services by email, postal
                        mail, or telephone, you may select the option stating
                        that you do not wish to receive marketing messages.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Povital occasionally allows other companies to offer our
                        registered customers information about their products
                        and services, using postal mail only. If you do not want
                        to receive these offers, you may select the option
                        stating that you do not wish to receive marketing
                        materials from third parties.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b> Access</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We will provide you the means to ensure your personal
                        information is correct and current. You may review and
                        update this information at any time at the Visitor
                        Center. There, you can:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            View and edit personal information you have already
                            given us
                          </li>
                          <li>
                            {" "}
                            Tell us whether you want to receive marketing
                            information
                          </li>

                          <li>
                            {" "}
                            Tell us whether you want third parties to send you
                            their offers by postal mail
                          </li>
                          <li>
                            {" "}
                            Sign up for electronic newsletters about our
                            services and products
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b> Third Party Links</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        The Povital Services may provide links to other websites
                        or resources over which Povital does not have control
                        (External Web Sites). Such links do not constitute an
                        endorsement by Povital and they are provided to you only
                        as a convenience. Povital is not responsible for the
                        content of External Web Sites and your use of External
                        Web Sites is subject to the terms of use and privacy
                        policies located on the applicable External Web Site. We
                        encourage you to read the privacy statements of External
                        Web Sites that collect your personal information.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b> Third Party Websites</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        You can access Povital and its services from several
                        third-party websites (in the form of plug-ins, addins,
                        etc). When you do so, you are thereby subject to the
                        policies of that site regarding privacy and data
                        collection and you should read those sites’ privacy
                        policies to make sure you agree to them befor e usage.
                        Povital does not collect, transmit, or process data from
                        any plug-ins such as the:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>Office 365 Outlook Add-in</li>
                          <li> Desktop Outlook Plug-in</li>

                          <li> Windows Plug-in</li>
                          <li> Google Chrome Plug-in</li>
                          <li> Gmail Add-on</li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b> Electronic Product Registration</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        When you buy and install a new product, we may ask you
                        to register your purchase electronically. When you do,
                        we merge your registration information with any
                        information you’ve already provided (we call that
                        information your personal profile). If you haven’t
                        previously registered with us, we create a personal
                        profile for you from your product registration
                        information. If you ever want to review or update that
                        information, you can visit the Profile Center, click on
                        Update Profile, and edit any of the Personal Information
                        in your profile. If you haven’t already created a
                        Registration ID, we will ask you to do so. This ensures
                        that only you can access your information.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>Customer Profiles</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        As mentioned above, every registered customer has a
                        unique personal profile. Each profile is assigned a
                        unique personal identification number, which helps us
                        ensure that only you can access your profile.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        When you register, we create your profile, assign a
                        personal identification number, then send this personal
                        identification number back to your hard drive in the
                        form of a cookie. This code is uniquely yours and acts
                        as your passport to travel across website, allowing you
                        to download free software, order free newsletters, and
                        visit premium sites without having to fill out
                        registration forms with information you’ve already
                        provided. Even if you switch computers, you won’t have
                        to re-register – just use your Registration ID to
                        identify yourself.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>CAN-SPAM Compliance</b>
                      </Typography>
                      <Typography
                        sx={{ fontSize: "16px !important", userSelect: "none" }}
                      >
                        We have taken the necessary steps to ensure that we are
                        compliant with the CAN-SPAM Act of 2003.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>Enforcement</b>
                      </Typography>
                      <Typography
                        sx={{ fontSize: "16px !important", userSelect: "none" }}
                      >
                        If for some reason you believe Povital has not adhered
                        to these principles, please notify us by email at
                        support-th@povital.com, and we will do our best to
                        correct the problem promptly. Be certain the words
                        “Privacy Policy” are in the email subject line.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>Acceptable Use Policy</b>
                      </Typography>

                      <Typography
                        sx={{ fontSize: "16px !important", userSelect: "none" }}
                      >
                        If for some reason you believe Povital has not adhered
                        to these principles, please notify us by email at
                        support-th@povital.com, and we will do our best to
                        correct the problem promptly. Be certain the words
                        “Privacy Policy” are in the email subject line.
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>Your Consent</b>
                      </Typography>
                      <Typography
                        sx={{ fontSize: "16px !important", userSelect: "none" }}
                      >
                        By using our site, you consent to our privacy policy.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>Privacy Policy Customer Pledge</b>
                      </Typography>
                      <Typography
                        sx={{ fontSize: "16px !important", userSelect: "none" }}
                      >
                        We pledge to you, our customer, that we have made a
                        dedicated effort to bring our privacy policy in line
                        with the following important privacy laws and
                        initiatives:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>Federal Trade Commission Fair</li>
                          <li> Children’s Online Privacy Protection Act</li>

                          <li>Privacy Alliance</li>
                          <li>
                            {" "}
                            Controlling the Assault of Non-Solicited Marketing
                            Activities
                          </li>
                          <li> Trust Guard Privacy Requirements</li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        PLEASE NOTE: This online privacy policy applies only to
                        information collected through our website and not to
                        information collected offline.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "20px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>Zoom Integration Privacy Policy</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Povital is committed to protecting our customers’
                        privacy because we believe your business belongs to you.
                        Povital complies with worldwide practices for protecting
                        customer privacy and data in order to protect your
                        privacy. This Privacy Policy describes our policies and
                        procedures on the collection, use, and disclosure of
                        your Personal Data when you use the{" "}
                        <b>Zoom Integration</b> and tells you about your privacy
                        rights and how the law protects You.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We use your Personal data to provide and improve the
                        Zoom Integration service. By using this service, you
                        agree to the collection and use of information in
                        accordance with this Privacy Policy.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>1. Data Collection</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We collect your information via cookies, and certain
                        Information by call or e-mail if it required regarding
                        of any technical error during the services. The data
                        collected via phone call or e-mail include Type
                        (Incoming/Outgoing). These call logs are generated on
                        your request but are not stored in Povital’s system.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We use Cookies and similar tracking technologies to
                        track the activity on our Service and store certain
                        information. Tracking technologies used are beacons,
                        tags, and scripts to collect and track information and
                        to improve and analyze our service. Please read
                        Povital’s Privacy Policy for more information on
                        cookies.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        The other identifiable information/ data collected are
                        email address, first name, last name, phone number, and
                        usage data. This identifiable data is collected via an
                        access token to initiate a Zoom call.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>2. Reasons for Personal Data Collection</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>To provide and maintain the service,</b> including
                        monitoring the usage of Zoom Service.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>To manage your Account:</b> to manage your
                        registration as a user of the service. The personal data
                        you provide can give you access to different
                        functionalities of the service that are available to you
                        as a registered user. including monitoring the usage of
                        Zoom Service.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>For the performance of service: </b> the development,
                        compliance, or services you have purchased or of any
                        other contract with us through this Service.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>To contact you:</b> To contact you by email,
                        telephone calls, SMS, or other equivalent forms of
                        electronic communication, such as notifications
                        regarding updates or informative communications related
                        to the functionalities, products, or contracted
                        services, including security updates, when necess ary or
                        reasonable for their implementation.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>To manage your requests:</b> To attend and manage
                        your requests to us.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>3. Disclosure of Your Personal Data</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>We don’t use/ disclose your data </b> for any other
                        purpose such as Advertising or Marketing using profiles
                        based on such data, conducting or assisting with
                        surveillance, or reconstructing the profiles.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>We may disclose your personal information,</b>{" "}
                        without notice, if required to do so by law or in the
                        belief that such action is necessary to:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li style={{ listStyle: "none" }}>
                            1. Confirm to the edicts of the law or comply with
                            legal process served on the site
                          </li>
                          <li style={{ listStyle: "none" }}>
                            2. Protect and defend the rights or property of
                            Povital and its family of websites
                          </li>

                          <li style={{ listStyle: "none" }}>
                            3. Act in urgent circumstances to protect the
                            personal safety of users, their websites, or the
                            public
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>4. Securing Your Data</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We take the necessary steps to ensure that your data is
                        protected. We have put physical and technical safeguards
                        in place to keep the data we collect secure. We also
                        take appropriate measures, in compliance with applicable
                        law, to ensure that your Personal Data collected by Zoom
                        remains secure. However, please note that although we
                        take responsible steps to protect your data, no website,
                        internet transmission, computer system, or wireless
                        connection is completely secure.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>5. Transfer of Your Personal Data</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Your information, including Personal Data, is processed
                        at the Company’s operating offices and in any other
                        places where the parties involved in the processing are
                        located. It means that this information may be
                        transferred between Povital’s operating offices located
                        in the US and India and maintained on Povital’s
                        computers located outside of your state, province,
                        country, or other governmental jurisdiction where the
                        data protection laws may differ than those from your
                        jurisdiction.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Your consent to this Privacy Policy followed by your
                        submission of such information represents your agreement
                        to that transfer.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We take all steps reasonably necessary to ensure that
                        your data is treated securely and in accordance with
                        this Privacy Policy and no transfer of your Personal
                        Data will take place to an organization or a country
                        unless there are adequate controls in place including
                        the security of Your data and other personal
                        information.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>6. Your Rights</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Your personal information belongs to you. In accordance
                        with the applicable law, you have the right to ask us to
                        provide details about what we have collected, to delete
                        it, or to exercise any other right you may have.
                        However, requesting the deletion of your personal data
                        may also result in a loss of access to the Zoom
                        integration service we provide. We will not delete data
                        that we are required by law to retain.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        To enquire more about your rights please{" "}
                        <b style={{ textDecoration: "underline" }}>
                          contact us.
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>7. Data Retention</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        The Povital system will retain your Personal Data only
                        as long as necessary for the purposes set out in this
                        Privacy Policy. We will retain and use your Personal
                        Data to the extent necessary to comply with our legal
                        obligations (for example, if we are required to retain
                        your data to comply with applicable laws), resolve
                        disputes, and enforce our legal agreements and policies.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        The system will also retain Usage Data for internal
                        analysis purposes. Usage Data is generally retained for
                        a shorter period of time, except when this data is used
                        to strengthen the security or to improve the
                        functionality of Zoom along with Povital ATS, or we are
                        legally obligated to retain this data for longer time
                        periods.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>8. Deletion of personal data</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We ensure that anytime data subjects/ users can
                        disconnect the Zoom integration. All the integration
                        information collected throughout the usage will be
                        deleted from our system.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Our system may give you the ability to delete certain
                        information about you from within the system. You may
                        update, amend, or delete your information at any time by
                        signing in to your Account and visiting the account
                        settings section that allows you to manage your personal
                        data. You may also contact us to request access to,
                        correct, or delete any personal data that you have
                        provided to us.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Please note, however, that we may need to retain certain
                        information when we have a legal obligation or lawful
                        basis to do so.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>9. Contact us</b>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        Please read the Povital Privacy Policy for more
                        information. If you have any questions about this
                        Privacy Policy, you can contact us: By email:
                        compliance@povital.com
                      </Typography>
                    </Box>
                  </Grid>
                </Box>


              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Box>
      <Footer />
    </Box>
  );
};

export default Privacy;
